import i18next from "i18next";
import { I18nManager } from "./I18nManager";
import { II18nManager } from "./interfaces/II18nManager";

export const i18nManager: II18nManager = new I18nManager(i18next);
